import { trackElementInteraction } from '../util/analytics'

up.compiler('[training-ground-summary--back]', (element) => {

  const searchFormContainer = document.querySelector('.training-grounds--search')
  const searchForm = document.querySelector('.training-grounds--search form')
  const summary = document.querySelector('[training-ground-summary]')

  function showSearchResults() {
    trackElementInteraction(element, 'click.element')
    up.emit(searchForm, 'up:form:submit')
    summary.innerHTML = ''
    searchFormContainer.classList.remove('hidden')
  }

  element.addEventListener('click', showSearchResults)
})
